<h1 mat-dialog-title class="dialog-title-with-action">
    {{ dialogTitle }}
    <button
        *ngIf="!isMultiSelectedTimecards"
        mat-mini-fab
        class="speed-dial-button jira-btn"
        (click)="openJira()"
        [matTooltip]="'Open In JIRA'"></button>
</h1>

<mat-dialog-content [formGroup]="timecardFormGroup" *ngIf="timecardFormGroup">
    <div fxLayoutAlign="space-around center">
        <mat-card (click)="$event.stopPropagation()">
            <mat-calendar
                [dateClass]="dateClass()"
                [startAt]="startAt"
                [dateFilter]="disableCalendarOnReadOrDelete"
                #calendar
                (selectedChange)="updateFormDate($event, calendar)"></mat-calendar>
        </mat-card>
        <div>
            <mat-form-field fxFill>
                <mat-label>Employee</mat-label>
                <input
                    matInput
                    formControlName="employee"
                    aria-label="Employee"
                    [matAutocomplete]="autoEmployees"
                    (ngModelChange)="employeeQuerySearch($event)" />
                <button
                    *ngIf="isEmployeeSelected()"
                    [disabled]="isReadDeleteOrLocked()"
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="clearEmployee()">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="employeeControl.hasError('required')">
                    Employee is <strong>required</strong>
                </mat-error>
                <mat-error *ngIf="employeeControl.hasError('employeeNotInList')">
                    Employee not <strong>found</strong>
                </mat-error>
            </mat-form-field>
            <mat-autocomplete #autoEmployees="matAutocomplete">
                <mat-option *ngFor="let employee of filteredEmployees; trackBy: trackBy" [value]="employee.fullName">{{
                    employee.fullName
                }}</mat-option>
            </mat-autocomplete>

            <mat-form-field fxFill>
                <mat-label>Client-Project</mat-label>
                <input
                    matInput
                    formControlName="clientProject"
                    aria-label="Client-Project"
                    [matAutocomplete]="autoClients"
                    (ngModelChange)="clientQuerySearch($event)" />
                <button
                    *ngIf="isClientSelected()"
                    [disabled]="isReadDeleteOrLocked()"
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="clearClient()">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="clientProjectControl.hasError('required')">
                    Client-Project is <strong>required</strong>
                </mat-error>
                <mat-error *ngIf="clientProjectControl.hasError('timesheetProjectNotInList')">
                    Client-Project is not <strong>found</strong>
                </mat-error>
            </mat-form-field>
            <mat-autocomplete #autoClients="matAutocomplete">
                <mat-option
                    *ngFor="let project of filteredTimeSheetProjects; trackBy: trackBy"
                    [value]="this.getProjectName(project)"
                    >{{ this.getProjectName(project) }}</mat-option
                >
            </mat-autocomplete>

            <div fxLayoutAlign="space-around center">
                <mat-form-field>
                    <mat-label>TO charge</mat-label>
                    <input matInput aria-label="TO charge" formControlName="toCharge" />
                    <mat-error *ngIf="toChargeControl.hasError('chargeFormat')">
                        TO charge is <strong>wrongly formatted</strong>
                    </mat-error>
                </mat-form-field>
                <button
                    mat-icon-button
                    *ngIf="!isMultiSelectedTimecards"
                    [disabled]="isReadDeleteOrLocked()"
                    (click)="swapCharges()"
                    color="warn">
                    <mat-icon>swap_horiz</mat-icon>
                </button>
                <button
                    mat-icon-button
                    *ngIf="isMultiSelectedTimecards"
                    [disabled]="isReadDeleteOrLocked()"
                    (click)="chargesToToCharge()"
                    color="warn">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                <button
                    mat-icon-button
                    *ngIf="isMultiSelectedTimecards"
                    [disabled]="isReadDeleteOrLocked()"
                    (click)="chargesToNoCharge()"
                    color="warn">
                    <mat-icon>arrow_forward</mat-icon>
                </button>
                <mat-form-field>
                    <mat-label>NO charge</mat-label>
                    <input matInput aria-label="NO charge" formControlName="noCharge" />
                    <mat-error *ngIf="noChargeControl.hasError('chargeFormat')">
                        NO charge is <strong>wrongly formatted</strong>
                    </mat-error>
                </mat-form-field>
                <span style="font-weight: bold">
                    <mat-icon color="primary" matTooltipClass="my-tooltip" matTooltip="{{ CHARGE_INFO }}"
                        >help_outline</mat-icon
                    >
                </span>
            </div>
        </div>
    </div>
    <div class="multiple-months-selected" *ngIf="multipleMonthsSelected">
        Caution: dates within multiple months are selected!
    </div>
    <div *ngIf="!isMultiSelectedTimecards">
        <div class="timecard-overview-title">
            <mat-form-field fxFill>
                <mat-label>Title</mat-label>
                <input matInput aria-label="Title" formControlName="issueTitle" required />
                <mat-error *ngIf="issueTitleControl.hasError('required')">
                    Title is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field fxFill>
                <mat-label>Comment</mat-label>
                <textarea matInput aria-label="Comment" formControlName="comment"></textarea>
            </mat-form-field>
        </div>
    </div>
    <div *ngIf="isMultiSelectedTimecards && selectedTimeCardContainerGroup" class="selected-timecards">
        <mat-card>
            <mat-card-title>{{ selectedTimeCardContainerGroup.length }} Timecards selected</mat-card-title>
            <mat-card-content *ngFor="let timeCard of selectedTimeCardContainerGroup; trackBy: trackBy">
                {{ timeCard.date.toISOString().slice(0, 10) }} | {{ timeCard.hoursToCharge }} h |
                {{ timeCard.hoursNoCharge }} h | {{ timeCard.fullName }} | {{ timeCard.clientName }} |
                {{ timeCard.timesheetProjectName }} | {{ timeCard.tag }} |
                {{ timeCard.issueTitle }}
            </mat-card-content>
        </mat-card>
    </div>

    <div *ngIf="issuePriority">
        <span style="padding-left: 3px"
            >PRIORITY (JIRA):
            <span [class.warn]="isIssuePriorityRed()" class="bold">{{ issuePriority | uppercase }}</span>
        </span>
    </div>

    <mat-error
        fxLayout="column"
        fxLayoutAlign="center center"
        class="cross-field-validation"
        *ngIf="
            timecardFormGroup.errors?.atleastOneChargeRequired && (timecardFormGroup.touched || timecardFormGroup.dirty)
        ">
        <span>Atleast one of the following properties is required: 'TO charge' or 'NO charge'.</span>
    </mat-error>
    <mat-error
        fxLayout="column"
        fxLayoutAlign="center center"
        class="cross-field-validation"
        *ngIf="timecardFormGroup.errors?.exceededTwelveHours && (timecardFormGroup.touched || timecardFormGroup.dirty)">
        <span>The sum of 'TO charge' and 'NO charge' cannot exceed 12 hours.</span>
    </mat-error>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button color="primary" mat-dialog-close (click)="cancelDialog()">
        <span>Cancel</span>
    </button>
    <button
        *ngIf="!isRead()"
        mat-flat-button
        (click)="crud === 4 ? deleteTimecard() : saveTimecard()"
        [disabled]="crud !== 4 && timecardFormGroup && (!timecardFormGroup.valid || isBusy)"
        [color]="crud !== 4 ? 'primary' : 'warn'">
        <span *ngIf="crud === 1">Create</span>
        <span *ngIf="crud === 3">Save</span>
        <span *ngIf="crud === 4">Delete</span>
    </button>
</mat-dialog-actions>
